// src/store/state.js
export default {
    userid:'',
    userinfo:{
        userid:'',
        username:'',
        userpassword:'',
        userposition:'',
        role: '', // 添加角色
        permissions: [] // 添加权限数组
    },
    usermessage:[
        
    ],
    useruncheckmessage:[

    ],
    useruncheckmessagenumber:'',
    LightViewToken:'100031026095'
}
